// Simple className combiner used across components (cn)
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(" ")


 function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}}